import React from 'react';
import { useTable, useSortBy, useFilters } from "react-table";
import Icon from '../ui/elements/Icon';
import Currency from '../ui/elements/Currency';

import "./OrderShow.css";



function Table({ columns, data }) {
  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns,
    data,
    defaultColumn,
    initialState: {
      sortBy: [
        {
          id: 'article',
          desc: false
        }
      ]
    }
  },
    useFilters,
    useSortBy
  );

  return (
    <table className="table is-bordered is-striped is-hoverable is-fullwidth is-narrow" {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column, i) => (
              <th
                className="has-text-centered is-nowrapped" key={i}
              >
                <div key="0" {...column.getHeaderProps(column.getSortByToggleProps({ title: 'Сортировать' }))}>
                  {!column.disableSortBy ?
                    (<React.Fragment>
                      {column.render('Header')}{' '}<Icon icon={column.isSorted ? (column.isSortedDesc ? "caret-down" : "caret-up") : "sort"} />
                    </React.Fragment>)
                    :
                    column.render('Header')
                  } </div>
                <div style={{ marginTop: "5px" }} key="1">{column.canFilter ? column.render('Filter') : null}</div>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row)
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
              })}
            </tr>
          )
        })}
      </tbody>
      <tfoot>
        <tr>
          <td className="has-text-right is-size-2" colSpan="9">
            <Currency value={rows.reduce((a, b) => parseInt(a) + parseInt(b.values['sum']), 0)} />
          </td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  );
}

const Shipments = ({ values }) => {
  if (values.length > 1) {
    return (
      <ul>
        {values.map((shipment, idx) => {
          return (
            <li className="has-text-centered" key={idx}><a href={`/office/shipments/${shipment[1]}`} target="_blank">
              {shipment[0]}
            </a></li>
          );
        })}
      </ul>
    );
  } else {
    if (values.length == 0) {
      return (
        <p className="has-text-centered">—</p>
      );
    } else {
      return (
        <a className="has-text-centered" href={`/office/shipments/${values[0][1]}`} target="_blank">
          {values[0][0]}
        </a>
      );
    }
  }
};

const Statuses = ({ values }) => {
  if (values.length > 1) {
    return (
      <ul>
        <li className="is-nowrapped" key="0">из которых:</li>
        {values.map((status, idx) => {
          return (
            <li className="is-nowrapped" key={idx + 1} >
              {status[1]}
            </li>
          );
        })}
      </ul>
    );
  } else {
    if (values.length == 0) {
      return (
        <p className="has-text-centered">—</p>
      );
    } else {
      return (
        <p className="has-text-centered is-nowrapped" >
          {values[0][1]}
        </p>
      );
    }
  }

};

function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {

  return (
    <input
      className="input is-small"
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined)
      }}
      placeholder={`Поиск...`}
    />
  )
}

function multiSelectFilter(rows, columnIds, filterValue) {
  return filterValue.length === 0 ? rows : rows.filter((row) => {
    const options = [];
    row.values[columnIds].forEach(v => {
      options.push(v[0]);
    })

    // return filterValue.includes(options[0])
    return options.some(el => filterValue.includes(el));
  })
}

function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {

  const options = React.useMemo(() => {
    const options = new Set()
    preFilteredRows.forEach(row => {
      options.add(row.values[id])
    })
    return [...options.values()]
  }, [id, preFilteredRows])

  return (
    <div className="select is-small">
      <select
        value={filterValue}
        onChange={e => {
          setFilter(e.target.value || undefined)
        }}
      >
        <option value="">Все</option>
        {options.map((option, i) => (
          <option key={i} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  )
}

function SelectStatusFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  // Calculate the options for filtering
  // using the preFilteredRows
  const options = React.useMemo(() => {
    const options = new Set()
    preFilteredRows.forEach(row => {
      row.values[id].forEach(v => {
        options.add(v[0]);
      })
    })
    return [...options.values()]
  }, [id, preFilteredRows])

  return (
    <div className="select is-small">
      <select
        value={filterValue}
        onChange={e => {
          setFilter(e.target.value || undefined)
        }}
      >
        <option value="">Все</option>
        {options.map((option, i) => (
          <option key={i} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  )
}

function NumberRangeColumnFilter({
  column: { filterValue = [], preFilteredRows, setFilter, id },
}) {
  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    preFilteredRows.forEach(row => {
      min = Math.min(row.values[id], min)
      max = Math.max(row.values[id], max)
    })
    return [min, max]
  }, [id, preFilteredRows])

  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      <input
        value={filterValue[0] || ''}
        className="input is-small"
        onChange={e => {
          const val = e.target.value
          setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
        }}
        placeholder={`${min}`}
        style={{
          width: '55px',
          marginRight: '0.3rem',
        }}
      />
      —
      <input
        value={filterValue[1] || ''}
        className="input is-small"
        onChange={e => {
          const val = e.target.value
          setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
        }}
        placeholder={`${max}`}
        style={{
          width: '55px',
          marginLeft: '0.3rem',
        }}
      />
    </div>
  )
}

class OrderShow extends React.Component {
  constructor(props) {
    super(props);

    const sdata = [];
    this.props.orderParts.map((orderPart, i) =>
      sdata.push({
        brand: orderPart.part.brand.name,
        article: orderPart.part.article,
        description: orderPart.part.description,
        source: orderPart.source ? orderPart.source.name : '',
        qty: orderPart.qty,
        status: orderPart.statusArray,
        shipments: orderPart.shipmentsArray,
        price: orderPart.price,
        sum: orderPart.sum,
        prepay: orderPart.rebateClauseId ? 'Требуется предоплата' : ''
      })
    );


    this.state = {
      data: sdata
    }
  }

  render() {
    const columns = [
      {
        Header: 'Бренд',
        accessor: 'brand',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered">
              {value}
            </p>
          );
        }
      },
      {
        Header: 'Артикул',
        accessor: 'article',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered"><a href={`/${this.props.employee ? 'office/' : ''}parts/search?query=${value}&mode=article`} target="_blank">
              {value}
            </a></p>
          );
        },
        sortType: 'basic'
      },
      {
        Header: 'Наименование детали',
        accessor: 'description',
      },
      {
        Header: 'Склад',
        accessor: 'source',
        Filter: SelectColumnFilter,
        filter: 'includes',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered">
              {value}
            </p>
          );
        }
      },
      {
        Header: 'Количество',
        accessor: 'qty',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered">
              {value}
            </p>
          );
        }
      },
      {
        Header: 'Статус',
        accessor: 'status',
        Filter: SelectStatusFilter,
        filter: multiSelectFilter,
        Cell: ({ cell: { value } }) => <Statuses values={value} />
      },
      {
        Header: 'Отгрузки',
        accessor: 'shipments',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ cell: { value } }) => <Shipments values={value} />
      },
      {
        Header: 'Цена',
        accessor: 'price',
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="is-nowrapped has-text-right"><Currency value={Math.round(value)} /></p>
          );
        }
      },
      {
        Header: 'Сумма',
        accessor: 'sum',
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="is-nowrapped has-text-right"><Currency value={Math.round(value)} /></p>
          );
        }
      },
      {
        Header: '',
        disableSortBy: true,
        disableFilters: true,
        accessor: 'prepay',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered is-size-7 has-text-danger-dark">{value}</p>
          );
        }
      }
    ];


    return (
      <div className="order_parts_table">
        <Table columns={columns} data={this.state.data} />
      </div>
    );
  }
}

OrderShow.propTypes = {};

export default OrderShow;
